import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  exportTimeKeepingMonthStart,
  exportTimeKeepingMonthSuccess,
  exportTimeKeepingMonthFailed,
} from "../redux/exportTimeKeepingMonth";

import { exportTimeKeepingMonthApi } from "core/http/service/timeKeeping";
import { toast } from "react-toastify";
import { exportFileExcel } from "helper/utils";

function* exportTimeKeepingMonthWork(action) {
  try {
    const res = yield call(exportTimeKeepingMonthApi, action.payload);

    yield exportFileExcel(res, "DS_cham_cong_thang.xlsx");

    yield put({
      type: exportTimeKeepingMonthSuccess.type,
    });
  } catch (error: any) {
    yield put({
      type: exportTimeKeepingMonthFailed.type,
    });
    toast.error("Đã có lỗi xảy ra");
  }
}

function* watchExportTimeKeepingMonth() {
  yield takeLatest(
    exportTimeKeepingMonthStart.type,
    exportTimeKeepingMonthWork
  );
}

export default function* exportTimeKeepingMonthSaga() {
  yield all([watchExportTimeKeepingMonth()]);
}
